/* eslint-disable */
import React, {Component} from "react"
import Map from 'ol/Map';
import View from 'ol/View';
import {Tile,} from 'ol/layer';
import {defaults as defaultInteractions, DragRotateAndZoom} from 'ol/interaction';
import {XYZ, OSM,} from 'ol/source';
// import {TianMap} from  '../../common/TianDiTu';
import {Projection} from 'ol/proj';

var ol = require('ol');

const height = document.body.clientHeight;
const width = document.body.clientWidth;

class Main extends Component {
    // 2.dom渲染成功后进行map对象的创建
    componentDidMount() {
        this.initMap();
    }

    initMap() {
        /*    var GisMap = new Map({
         interactions: defaultInteractions().extend([
         //拖拽旋转
         new DragRotateAndZoom()
         ]),
         layers: [
         new TileLayer({
         source: new OSM()
         })
         ],
         view: new View({
         center: [0, 0],
         zoom: 2
         }),
         target: 'map',
         });*/

        // var gaodeMapLayer = new TileLayer({
        //     source: new XYZ({
        //         url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}'
        //     })
        // });


        /*   var map = new Map({
         // layers: [gaodeMapLayer],
         view: new View({
         center: [118.803805,32.064241],
         projection: 'EPSG:4326',
         zoom: 12
         }),
         target: 'map'
         });
         var tianMapSat = new TileLayer({
         title: "天地图卫星",
         source: new TianMap({mapType:"sat"})
         });
         map.addLayer(tianMapSat);*/

        //天地图底图
        var source = new XYZ({
            url: "http://t4.tianditu.com/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=01648a46241de4244d518d8e151b3528"
        });
        var tileLayer = new Tile({
            title: "天地图",
            source: source
        });
        //标注图层
        var sourceMark = new XYZ({url: 'http://t3.tianditu.com/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=01648a46241de4244d518d8e151b3528'});
        var tileMark = new Tile({
            title: "标注图层",
            source: sourceMark,

        });
        //卫星图像
        var sourceSatellite = new XYZ({url: 'http://t3.tianditu.com/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=01648a46241de4244d518d8e151b3528'});
        var tileSatellite = new Tile({
            title: "卫星图",
            source: sourceSatellite

        });
        var projection = new Projection({
            code: 'EPSG:4326',
            units: 'degrees'
        });
        var map = new Map({
                layers: [
                    tileLayer,
                    tileMark
                ],
                view: new View({
                    zoom: 11,
                    projection: projection,
                    center: [118.803805, 32.064241],
                    //ol.proj.transform( [116.40769, 39.89945], 'EPSG:4326', 'EPSG:3857')
                }),
                target: 'map'
            })


            // var projection = new Projection({
            //     code: 'EPSG:4326',
            //     units: 'degrees'
            // });
            // var map = new ol.Map({
            //         target: 'map',
            //         layers: [
            //             new Tile({
            //                 source: new XYZ({
            //                     url:'https://t{s}.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=01648a46241de4244d518d8e151b3528',
            //                     // url:'https://t0.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=2ce94f67e58faa24beb7cb8a09780552',
            //                     // url: 'https://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=01648a46241de4244d518d8e151b3528',
            //                 }),
            //                 isGroup: true,
            //                 name: '天地图路网'
            //             }),
            //             // new Tile({
            //             //     source: new XYZ({
            //             //         url: 'https://t0.tianditu.gov.cn/DataServer?T=cia_w&x={x}&y={y}&l={z}&tk=2ce94f67e58faa24beb7cb8a09780552'
            //             //     }),
            //             //     isGroup: true,
            //             //     name: '天地图文字标注'
            //             // }),
            //             // new Tile({
            //             //     title: "天地图路网",
            //             //     source: new XYZ({
            //             //         url: "http://t0.tianditu.com/DataServer?T=vec_w&x={x}&y={y}&l={z}"
            //             //     })
            //             // }),
            //             // new Tile({
            //             //     title: "天地图文字标注",
            //             //     source: new XYZ({
            //             //         url: 'http://t0.tianditu.com/DataServer?T=cva_w&x={x}&y={y}&l={z}'
            //             //     })
            //             // }),
            //         ],
            //
            //         view: new View({
            //             projection: projection,
            //             center: [118.803805, 32.064241],
            //             zoom: 12
            //         })
            //     })
        ;
    }

    render() {
        // 1.创建地图容器
        return <div id="map" className="map" style={{height, width}}></div>
    }

}

export default Main;
